export function IntroductionCard() {
  return (
    <div className="bg-[#050614]/60 border border-[#1a2d4d] rounded-xl p-6 backdrop-blur-sm">
      <div className="flex items-center mb-4">
        <div className="w-1 h-6 bg-gradient-to-b from-[#4f46e5] to-[#06b6d4] rounded-full mr-3"></div>
        <h3 className="text-lg font-semibold text-white">About This Tool</h3>
      </div>
      <p className="text-sm text-gray-400 leading-relaxed">
        You will craft your own scene using this custom tool and a pre-determined branching
        structure capable of supporting conversations for a variety of genres and dynamics. At the
        end, you will have a fully playable, five-minute game -- with no code required.
      </p>
    </div>
  );
}
